export default "__VITE_ASSET__2598f32a__"